import React from 'react';

import {HoistedTag} from 'inventory/InventoryFileConstants';
import TagValueViewer from 'metadata/TagValueViewer';

interface HoistedTagValueCellProps {
  tag: HoistedTag;
}

export default function HoistedTagValueCell(props: HoistedTagValueCellProps): JSX.Element {
  return (
    <div className="metadata-field-row">
      <div className="metadata-field-col u-width-full">
        <TagValueViewer tag={props.tag} />
      </div>
    </div>
  );
}
